import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onAttributeChoiceSearch, onAttributeSearch } from "../../controller/AttributeController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination } from 'react-bootstrap';
import { Page } from "../../dto/page/Page";
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import { AttributeChoiceSearch } from "../../dto/attributechoice/AttributeChoiceSearch";
import { AttributeChoiceListEntity } from "../../dto/attributechoice/AttributeChoiceListEntity";
import { AttributeChoiceEntity } from "../../dto/attribute/AttributeChoiceEntity";

const AttributeChoiceList = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        }
    }, [])

    const [render, setRender] = useState(0);
    const [choiceSearch, setChoiceSearch] = useState<AttributeChoiceSearch>({
        id: undefined,
        attrbtName: '',
        attributeId: undefined,
        offset: -1,
        limit: 10
    });
    const [choices, setChoices] = useState<AttributeChoiceListEntity>({
        page: undefined,
        data: []
    });

    const choiceSearchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (choiceSearch.offset === 0) {
            const tmp = render + 1;
            setRender(tmp);
        } else {
            setChoiceSearch({
                ...choiceSearch,
                offset: 0
            })
        }
    }

    const choiceSearchFunction = async (offset: number | undefined) => {
        if (offset === undefined) {
            const response = await onAttributeChoiceSearch(choiceSearch);
            if (response.status === 0) {
                const pageable = response.data;
                const page: Page = {
                    limit: choiceSearch.limit,
                    totalElements: pageable.totalElements,
                    totalPages: pageable.totalPages,
                    offset: choiceSearch.offset
                }
                const beans: Array<AttributeChoiceEntity> = pageable.beans;
                setChoices({
                    page: page,
                    data: beans
                })
            } else {
                // error
            }
        } else {
            const tmpSearch: AttributeChoiceSearch = {
                id: choiceSearch.id,
                attributeId: choiceSearch.attributeId,
                offset: 0,
                limit: choiceSearch.limit
            }
            const response = await onAttributeChoiceSearch(choiceSearch);
            if (response.status === 0) {
                const pageable = response.data;
                const page: Page = {
                    limit: choiceSearch.limit,
                    totalElements: pageable.totalElements,
                    totalPages: pageable.totalPages,
                    offset: choiceSearch.offset
                }
                const beans: Array<AttributeChoiceEntity> = pageable.beans;
                setChoices({
                    page: page,
                    data: beans
                })
            } else {
                // error
            }
        }
    }

    const paginate = async (event: React.MouseEvent) => {
        event.preventDefault();
        const element = event.target as HTMLLinkElement;
        setChoiceSearch({
            ...choiceSearch,
            offset: parseInt(element.innerText) - 1
        });
    }

    useEffect(() => {
        if (choiceSearch.offset !== -1) {
            choiceSearchFunction(0);
        }
    }, [render]);

    useEffect(() => {
        if (choiceSearch.offset !== -1) {
            choiceSearchFunction(undefined);
        }
    }, [choiceSearch.offset]);

    return (
        <Container fluid>
            <div><Toaster position="top-right" reverseOrder={false}/></div>
            <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Атрибут choice</h3>
            <Row className="d-flex justify-content-center align-items-center mb-3">
                <Col md={12} lg={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <Form onSubmit={choiceSearchSubmit}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label> Атрибут нэр</Form.Label>
                                            <Form.Control size="sm" type="text" 
                                            onChange = {(event) => setChoiceSearch({
                                                ...choiceSearch,
                                                attrbtName: event.target.value
                                            })}/>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label>Багцлах</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select size="sm"
                                                    onChange={(event) => setChoiceSearch({
                                                        ...choiceSearch,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="1000000">Бүгд</option>
                                                </Form.Select>
                                                <Button variant="primary" size="sm" type="submit">
                                                    <SearchIcon fontSize="small"/>
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Header>
                        <Card.Body>
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Атрибут</th>
                                        <th>Утга</th>
                                        <th>Жин</th>
                                        <th>x</th>
                                        <th>y</th>
                                        <th>z</th>
                                        <th><InfoIcon /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        choices.data.map((data, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td>{data.attrbtName}</td>
                                                    <td>{data.valueText}</td>
                                                    <td>{data.defaultWeightGrams}</td>
                                                    <td>{data.defaultWeightGrams}</td>
                                                    <td>{data.defaultWeightGrams}</td>
                                                    <td>{data.defaultWeightGrams}</td>
                                                    <th><a href={`/attribute-choice/${data.id}`}><InfoIcon /></a></th>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>
            <Row>
                <Col md={12} lg={12} xs={12}>
                    {
                        choices.page &&
                        choices.page.totalPages > 1 && (
                        <Pagination>
                            {
                                choices.page.offset + 1 === 1 ? (
                                    <>
                                        <Pagination.Item active onClick={(event) => paginate(event)}>{choices.page.offset + 1}</Pagination.Item>
                                        <Pagination.Item onClick={(event) => paginate(event)}>{choices.page.offset + 2}</Pagination.Item>
                                    {
                                        (choices.page.offset + 2 < choices.page.totalPages) && ( 
                                        <>
                                            <Pagination.Ellipsis />
                                            <Pagination.Item onClick={(event) => paginate(event)}>{choices.page.totalPages}</Pagination.Item>
                                        </>
                                        )
                                    }
                                    </>
                                ) : (
                                    <>
                                        {
                                            choices.page.offset + 1 > 1 && (
                                                <>
                                                    {
                                                        choices.page.offset === 1 ? (
                                                            <Pagination.Item onClick={(event) => paginate(event)}>1</Pagination.Item>
                                                        ) : (
                                                            <>
                                                                <Pagination.Item onClick={(event) => paginate(event)}>1</Pagination.Item>
                                                                <Pagination.Ellipsis />
                                                                <Pagination.Item onClick={(event) => paginate(event)}>{choices.page.offset}</Pagination.Item>
                                                            </>
                                                        )
                                                    }
                                                    <Pagination.Item active onClick={(event) => paginate(event)}>{choices.page.offset + 1}</Pagination.Item>
                                                    {
                                                        choices.page.offset + 1 < choices.page.totalPages && (
                                                            <>
                                                                {
                                                                    choices.page.offset + 2 === choices.page.totalPages ? (
                                                                        <Pagination.Item onClick={(event) => paginate(event)}>{choices.page.totalPages}</Pagination.Item>
                                                                    ) : (
                                                                        <>
                                                                            <Pagination.Item onClick={(event) => paginate(event)}>{choices.page.offset + 2}</Pagination.Item>
                                                                            <Pagination.Ellipsis />
                                                                            <Pagination.Item onClick={(event) => paginate(event)}>{choices.page.totalPages}</Pagination.Item>
                                                                        </>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </Pagination>
                        )
                    }
                </Col>
            </Row>
        </Container>
    )
}

export default AttributeChoiceList;